module.exports = "/assets/data/6320650ce98c50fe845ee8432605c5ce-ME18.data.json";